<div class="app-container" [class.sidenav-expanded]="isExpanded">
  <!-- Header -->
  <header class="app-header">
    <div class="header-left">
      <img
        src="assets/images/itLOGO.png"
        alt="Logo"
        class="header-logo small-logo"
        (click)="toggleSidenav()"
      />
      <img
        src="assets/images/icetexLOGO.png"
        alt="Logo Expandido"
        class="header-logo large-logo"
        (click)="toggleSidenav()"
      />
    </div>
    <div class="header-right">
      <app-header [isExpanded]="isExpanded"></app-header>
    </div>
  </header>

  <!-- Main Container -->
  <div class="main-container">
    <!-- Sidenav -->
    <aside 
      class="app-sidenav" 
      [class.expanded]="isExpanded"
      (mouseenter)="expandSidenav()"
      (mouseleave)="collapseSidenav()"
    >
      <app-aside [isExpanded]="isExpanded"></app-aside>
    </aside>

    <!-- Overlay -->
    <div class="overlay" (click)="toggleSidenav()"></div>

    <!-- Content -->
    <main class="app-content">
      <app-bredcumbs></app-bredcumbs>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
